import { render, staticRenderFns } from "./UsuariosTableActions.vue?vue&type=template&id=15e994a1&scoped=true"
import script from "./UsuariosTableActions.vue?vue&type=script&lang=js"
export * from "./UsuariosTableActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e994a1",
  null
  
)

export default component.exports